// src/features/landing/infrastructure/jobCategoryApiRepository.js

const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

/**
 * 직종 코드 목록 조회
 * @param {string} [useType] - 'RECRUIT_OWNER' | 'RECRUIT_STAFF' (미지정 시 전체, RECRUIT_ALL은 양쪽 모두에 포함)
 * @returns {Promise<Array<{code: string, name: string, useType: string}>>}
 */
async function getJobCategories(useType) {
    const url = new URL(`${API_BASE_URL}/api/job-categories`);
    if (useType) url.searchParams.set('useType', useType);

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch job categories');
    }

    return response.json();
}

export const jobCategoryRepository = {
    getJobCategories,
};
